import {getStorageItem, setStorageItem} from '../../../services/storageService';
import {sendMonitor} from '../../../utils/monitoring';
import {isDevEnv} from '../../../utils/platform';
import {
    ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_FIRST_CYCLE,
    ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_SECOND_CYCLE,
    ISRAEL_TAX_REGULATION_UPDATE_SHOWN_TODAY
} from '../constants/featureConsts';
import {blacklist, featureMap, featurePulseCount, featuresIDs} from '../constants/map';
import {featurePopoverRef} from '../FeaturePopover.root';
import {addPortlet} from '../../Homepage/actions/dialogs';
import {TODOLIST_EXEC} from '../../ToDoList/consts';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';

const FEATURE_KEY = 'features';
const PULSE_COUNT_KEY = 'featuresPulseCount';

export async function getBlackList() {
    const rawBlacklist = await getStorageItem(FEATURE_KEY);
    const {features} = rawBlacklist;
    return features ? features.split(',') : [];
}
export function updateBlackList(value) {
    featureMap.delete(value);
    blacklist.push(value);
    const stringfyBlacklist = blacklist.join(',');
    setStorageItem(FEATURE_KEY, stringfyBlacklist);
}

export function clearStorage() {
    setStorageItem(FEATURE_KEY, '');
    setStorageItem(PULSE_COUNT_KEY, '');
}

export async function getPulseShownCountStorage() {
    const pulseCountStorage = await getStorageItem(PULSE_COUNT_KEY);
    const pulseCountObj = pulseCountStorage[PULSE_COUNT_KEY];
    return pulseCountObj ? JSON.parse(pulseCountObj) : {};
}
export function updatePulseShownCount(featureID: string) {
    const count = featurePulseCount[featureID];
    featurePulseCount[featureID] = !count ? 1 : count + 1;
    setStorageItem(PULSE_COUNT_KEY, JSON.stringify(featurePulseCount));
}

export function showReconFeature(formName: string, anchor) {
    let featureID = null;

    switch (formName) {
        case 'BANKRECON':
            featureID = featuresIDs.bankRecon;
            break;
        case 'ACCRECON':
            featureID = featuresIDs.accRecon;
            break;
        case 'FINVOICES':
            featureID = featuresIDs.exportInvoiceEOL;
            break;
        default:
            break;
    }

    if (featureID && featureID !== featuresIDs.exportInvoiceEOL) {
        featurePopoverRef?.current?.showFeaturePopover(featureID, anchor);
    }
}

export function showAnalyticsFeature(anchor) {
    // todo: AlexR - it looks like the fucntion is not used, should we remove it?
    featurePopoverRef?.current?.showFeaturePopover(featuresIDs.analytics, anchor);
}

export const isAutomation = (): boolean => {
    return window.location.search.includes('_automation');
};

export const addToDoListWidgetPortlet = async () => {
    const title = formsStore?.currentForm?.title;
    await addPortlet(TODOLIST_EXEC, title);
};

/**
 * @returns 1 for first cycle, 2 for second cycle, 0 for none
 */
export const IsraelTaxRegulationUpdateFeatureCycle = () => {
    const today = new Date(); // Get today's date
    const firstCycleStartDate = new Date('2026-01-01');
    const firstCycleEndDate = new Date('2026-01-16');
    const secondCycleStartDate = new Date('2026-05-16');
    const secondCycleEndDate = new Date('2026-06-16');
    const isDev = isDevEnv();
    if (isDev) {
        if (today <= firstCycleEndDate) return 1;
        else if (today >= secondCycleStartDate) return 2;
    }
    if (today >= firstCycleStartDate && today <= firstCycleEndDate) {
        return 1;
    } else if (today >= secondCycleStartDate && today <= secondCycleEndDate) {
        return 2;
    }
    return 0;
};

export const shouldShowIsraelTaxRegulationUpdateFeature = (formName: string): boolean => {
    // returns true if the feature should be shown
    const isCloud = isDevEnv() || window.location.host.includes('priority-connect');
    const cycle = IsraelTaxRegulationUpdateFeatureCycle();
    const isBetween = cycle > 0;
    const isBlockedByUser = !!window.localStorage.getItem(
        cycle === 1
            ? ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_FIRST_CYCLE
            : ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_SECOND_CYCLE
    );
    const shouldShowToday = !document.cookie.includes(ISRAEL_TAX_REGULATION_UPDATE_SHOWN_TODAY);
    return (
        isCloud &&
        shouldShowToday &&
        isBetween &&
        !isBlockedByUser &&
        (formName === 'DINVOICES' ||
            formName === 'AINVOICES' ||
            formName === 'CINVOICES' ||
            formName === 'EINVOICES' ||
            formName === 'RINVOICES' ||
            formName === 'YINVOICES' ||
            formName === 'PINVOICES' ||
            formName === 'SINVOICES' ||
            formName === 'FNCTRANS' ||
            formName === 'TINVOICES')
    );
};

export const setIsraelTaxRegulationUpdateCookie = () => {
    const midnight = new Date();
    midnight.setHours(23, 59, 59, 999);
    const utcMidnight = new Date(midnight.getTime() - midnight.getTimezoneOffset() * 60000);
    const expires = utcMidnight.toUTCString();

    document.cookie = `${ISRAEL_TAX_REGULATION_UPDATE_SHOWN_TODAY}=true; expires=${expires}; path=/`;
};

export const setIsraelTaxRegulationUpdateLocalStorage = (isButtonClicked?) => {
    if (isButtonClicked) {
        const cycle = IsraelTaxRegulationUpdateFeatureCycle();
        const storageKey =
            cycle === 1
                ? ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_FIRST_CYCLE
                : ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_SECOND_CYCLE;
        window.localStorage.setItem(storageKey, 'true');
        sendMonitor(storageKey);
    }
};
